/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = theme.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.addEventListener("DOMContentLoaded", function() {
  if (window.location.href.indexOf("/cart") > -1) {

    window.planIntervals = {};
    window.planIntervals.intervals = [];
    window.recurpayCart = {};
    window.subscriptionTitleArr = [];
    

    document.querySelector('[action="/cart"]').insertAdjacentHTML("beforebegin",`
<div class="mx-4 m-w-full mx-4-r"><div id="recurpay-cart-widget" class="mx-4 m-w-full mx-4-r">
<label for="one_time"><input type="radio" id="one_time" name="subscription_purchase" value="one_time"><span class="recurpay__checkmark"></span>One time purchase</label>
<label for="subscription">
<input type="radio" id="subscription" name="subscription_purchase" value="subscription"><span class="recurpay__checkmark"></span>Subscribe and Save</label></div></div>
`);
    document.querySelector('[for="subscription"]').insertAdjacentHTML("beforeend",'<div id="data-frequency-options"></div>');

    fetch('/cart.json').then(function(response) {
      return response.json();
    }).then(function(data) {
      window.recurpayCart = data;
      var cartItems = data.items;
      
      if(cartItems.length >0){
        
        var cartProducts = [];

        for(var i=0; i < cartItems.length; i++){
          var item = cartItems[i];

          cartProducts.push(item.product_id);

          if (item.selling_plan_allocation && subscriptionTitleArr.indexOf(item.selling_plan_allocation.selling_plan.name) === -1) {
            subscriptionTitleArr.push(item.selling_plan_allocation.selling_plan.name);
          }
          
        }
        
        function recurPDPModal(data){
          data.plans.forEach(plan => {
            if(plan.properties){
              window.planIntervals.intervals.push({
                interval:plan.properties.interval,
                title:plan.name,
                discount:plan.discount.value,
                description:plan.description
              });
            }
          });
        }
        
//           Getting all the plans associated with the cart products and filtering out all plans
        
        async function postData(url = '', data = {}) {
          const response = await fetch(url, {
            method: 'POST', 
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          });
          return response.json(); 
        }

        postData('https://macro-based-diner-1.recurpay.com/api/storefront/products/plans.json/restructure', {products: cartProducts})
        .then( response => {
          var collectionWidgetHTML = '';
          if(response != "ERROR" && response.success == true) {
            window.allPlans = response.data.plans;
            if(response.data.plans.length > 0){
              for(var i=0;i<response.data.plans.length;i++){
                recurPDPModal(response.data.plans[i]); 
              }
              var keyInterval = 'title';
              var filterInterval = [...new Map(window.planIntervals.intervals.map(item => [item[keyInterval], item])).values()];
              var htmlInterval = '';

              filterInterval.forEach(item => {
                if (item.discount != 0 ) {
                  htmlInterval += `<option value="${item.title}" data-title="${item.title}" data-description="${item.description}" data-discount="${item.discount}" data-plan-interval="${item.interval}">${item.title} <strong>(Save ${item.discount}%)</strong></option>`
                }
                else {
                  htmlInterval += `<option value="${item.title}" data-title="${item.title}" data-description="${item.description}" data-discount="${item.discount}" data-plan-interval="${item.interval}">${item.title}</option>`
                }
              });

              var selectData = '<select id="plan-selection"><option disabled value="noPlan" hidden selected>Select Frequency</option>'+htmlInterval+'</select>';

              document.querySelector('#data-frequency-options').innerHTML = selectData;

              if (subscriptionTitleArr.length == 1 ) {
                document.querySelector('#plan-selection').value = subscriptionTitleArr[0];
                document.querySelector('[value="subscription"]').checked = true;
              }
              else if ( subscriptionTitleArr.length == 0 ) {
                document.querySelector('[value="one_time"]').checked = true;
              }

            }
          }
        });
        
//           ----------------------------------------------------------------------------
        
        document.addEventListener('change',function(e){
          if(e.target && e.target.id== 'plan-selection'){
            var getPlanName = e.target.value;
            var createArrObj = [];
            var cartItems = recurpayCart.items;

            if(cartItems.length >0){

              for(var i=0; i < cartItems.length; i++){
                var index = i+1;
                var subscriptionProduct = false,
                    item = cartItems[i],
                    property = item.properties;

                var getObj = allPlans.find(x => x.product_id == item.product_id)
                if(getObj !== undefined){
                  var getFinalObj = getObj.plans.find(y => y.name == getPlanName);
                  if(getFinalObj !== undefined){

                    property["Plan"] = getPlanName;
                    property["_PlanId"] = getFinalObj.id;
                    createArrObj.push({
                      'line': index,
                      'selling_plan': getFinalObj.selling_plan_id,
                      'properties': property
                    })
                  }
                }
              }
            }

            for (var j=0; j<createArrObj.length;j++){
              planUpdate (createArrObj[j]);
            }
          }
          
          if(e.target && e.target.id== 'one_time'){
            var cartItems = recurpayCart.items;

            if (document.querySelector('#recurpay-cart-widget [name="subscription_purchase"]:checked').value == "one_time") {

              document.querySelector('#plan-selection').value = 'noPlan';

              if(cartItems.length >0){

                for(var i=0; i < cartItems.length; i++){
                  var index = i+1;
                  var item = cartItems[i],
                      property = item.properties;

                  property["Plan"] = '';
                  property["_PlanId"] = '';
                  var removedPlanLineItem = {
                    'line': index,
                    'selling_plan': null,
                    'properties': property
                  }
                  planUpdate (removedPlanLineItem);
                }
              }
            }
          }
          
        });
        
//           ---------------------------------------------------------------------------
        
        function planUpdate (UpdatedPlanObj) {
          async function postData(url = '', data = {}) {
            const response = await fetch(url, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            });
            return response.json(); 
          }

          postData('/cart/change.js', UpdatedPlanObj)
          .then(data => {
            priceUpdate (data)
          });
        }
        
        function priceUpdate (response) {
          var priceHtmls = Array.from(document.querySelectorAll('[data-line-id]'));
          var varIds = [];

          priceHtmls.forEach( element => varIds.indexOf(element.getAttribute('data-line-id')) === -1 ? varIds.push(element.getAttribute('data-line-id')) : null );

          varIds.forEach(varId => {
            const prodObj = response.items.find( itemObj => varId == itemObj.variant_id );
            const allElems = Array.from(document.querySelectorAll(`[data-line-id="${varId}"]`))

            allElems.forEach( element => element.innerHTML = Shopify.formatMoney(prodObj.final_line_price))
          });
        }

      }
    }).catch(function() {
      console.log("Error");
    });

  } 
}) 